import CritrereBoolController from './critere.bool.controller';

export default {
    bindings: {
        critere: '='
    },
    controller: CritrereBoolController,
    template: require('./critere.bool.tpl.html')
};
